module.exports = __webpack_public_path__ + "img/title-6.6794a891.png";